import { Modal, Row, Col, Spinner, Badge } from 'reactstrap';
import { motion } from 'framer-motion';
import { formatRoleName } from '../constants/utils';

const TechnicianModal = ({
  isOpen,
  toggle,
  technicianData,
  loading,
  formatCreatedDate,
  onTicketClick
}) => {
  if (!technicianData) return null;

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      size="lg"
      centered
      className="fade-scale-modal"
      style={{ maxHeight: '80vh' }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.2 }}
      >
        <div className="modal-header" style={{ position: 'sticky', top: 0, background: 'white', zIndex: 2 }}>
          <h5 className="modal-title">Technician Details - {technicianData.name}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={toggle}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body" style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          paddingTop: '0',
          maxHeight: 'calc(80vh - 60px)',
          overflow: 'auto'
        }}>
          {loading ? (
            <div className="text-center py-4">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Row className="mb-4">
                <Col md={6}>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Name:</span>
                    <span className="detail-value d-block" style={{ color: '#212529' }}>{technicianData.name}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Email:</span>
                    <span className="detail-value d-block">{technicianData.email || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Username:</span>
                    <span className="detail-value d-block">{technicianData.username || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Contact Number:</span>
                    <span className="detail-value d-block">
                      {technicianData.phoneCode ? `+${technicianData.phoneCode} ` : ''}
                      {technicianData.contactNumber || 'N/A'}
                    </span>
                  </div>
                   <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Organization Name:</span>
                    <span className="detail-value d-block">{technicianData.organization.name || 'N/A'}</span>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Role:</span>
                    <span className="detail-value d-block">{formatRoleName(technicianData.role) || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Verification Status:</span>
                    <span className="detail-value d-block">
                      <Badge color={technicianData.verified ? 'success' : 'danger'}>
                        {technicianData.verified ? 'Verified' : 'Not Verified'}
                      </Badge>
                    </span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Profile Image:</span>
                    {technicianData.profileUrl ? (
                      <img 
                        src={technicianData.profileUrl} 
                        alt="Profile" 
                        style={{ width: '50px', height: '50px', borderRadius: '50%', objectFit: 'cover' }}
                      />
                    ) : (
                      <span className="detail-value d-block">N/A</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Organization Contact Number:</span>
                    <span className="detail-value d-block">{technicianData.organization.contactNumber || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Organization Email:</span>
                    <span className="detail-value d-block">{technicianData.organization.email || 'N/A'}</span>
                  </div>
                  <div className="mb-3">
                    <span className="detail-label" style={{ fontWeight: 500, color: '#495057' }}>Attendance Status:</span>
                    <span className="detail-value d-block">
                      <Badge color={technicianData.attendanceStatus === 'ONLINE' ? 'success' : 'secondary'}>
                        {technicianData.attendanceStatus === 'ONLINE' ? 'Online' : 'Offline'}
                      </Badge>
                    </span>
                  </div>
                </Col>
              </Row>

              <h5 className="mb-3">Assigned Work Orders</h5>
              {technicianData.assignedTickets?.length > 0 ? (
                <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                  <table className="table table-sm">
                    <thead style={{ position: 'sticky', top: 0, background: 'white', zIndex: 1 }}>
                      <tr>
                        <th>Ticket #</th>
                        <th>Due Date</th>
                        <th>Asset</th>
                        <th>Status</th>
                        <th>Priority</th>
                      </tr>
                    </thead>
                    <tbody>
                      {technicianData.assignedTickets.map((ticket) => (
                        <tr key={ticket.id}>
                          <td>
                            <span 
                              className="text-primary cursor-pointer hover-underline"
                              onClick={() => onTicketClick(ticket.ticketNumber)}
                              style={{ cursor: 'pointer' }}
                            >
                              {ticket.ticketNumber}
                            </span>
                          </td>
                          <td>{formatCreatedDate(ticket.requestDate)}</td>
                          <td>{ticket.asset?.assetName || 'N/A'}</td>
                          <td>
                            <Badge color={
                              ticket.status === 'SUBMITTED' ? 'info' :
                              ticket.status === 'IN_PROGRESS' ? 'warning' :
                              ticket.status === 'ON_HOLD' ? 'danger' :
                              ticket.status === 'PENDING' ? 'primary' :
                              ticket.status === 'RESOLVED' ? 'success' : 'secondary'
                            }>
                              {ticket.status === 'SUBMITTED' ? 'OPEN' : ticket.status}
                            </Badge>
                          </td>
                          <td>
                            <Badge color={
                              ticket.urgencyLevel === 'SEVERE' ? 'danger' :
                              ticket.urgencyLevel === 'HIGH' ? 'warning' :
                              ticket.urgencyLevel === 'MEDIUM' ? 'info' :
                              ticket.urgencyLevel === 'LOW' ? 'primary' : 'secondary'
                            }>
                              {ticket.urgencyLevel || 'No Priority'}
                            </Badge>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="alert alert-info">No assigned work orders found</div>
              )}
            </>
          )}
        </div>
      </motion.div>
    </Modal>
  );
};

export default TechnicianModal;